/**
 * This is default flickity carousel class with a11y functions
 * Please fee free to update this class directly or inherit from it
 */
import Flickity from "flickity";
import {
  flickityReadyHandler,
  flickityChangeHandler,
  flickitySettleHandler,
} from "../utils/flickity";
import { checkMinViewport } from "./../utils/utils";

export default class ArticlePromoCarousel {
  constructor(elem, APP) {
    this.elem = elem;
    this.carousel_container = this.elem.querySelector(".apf-container");
    this.carousel = this.elem.querySelector(".js-slider");
    this.slides = this.elem.querySelectorAll(".js-slide");
    this.slideIndex = this.elem.querySelector(".js-slider-index");
    this.slideTotal = this.elem.querySelector(".js-slider-total");
    this.flkty;
    this.currentSlideIndex = 0;
    this.isMobileVP = !checkMinViewport(window.breakpoint);
    this.targetSlideWidth = this.isMobileVP
      ? this.carousel_container.offsetWidth - 40
      : this.carousel_container.offsetWidth;
    this.prevBtn = this.elem.querySelector(".flickity-prev-next-button");
    this.nextBtn = this.elem.querySelector(".flickity-prev-next-button");

    // todo
    // this.bgs = this.elem.parentElement.querySelectorAll(".js-spf-img");
    this.windowWidth = window.innerWidth;
  }

  updateSlideWidth() {
    this.slides.forEach((slide) => {
      slide.style.width = `${this.targetSlideWidth}px`;
    });

    let btnPos =
      (this.elem.offsetWidth - this.carousel_container.offsetWidth) / 2 +
      this.carousel_container.offsetWidth;

    if (this.prevBtn) {
      this.prevBtn.style.left =
        window.innerWidth < window.breakpoint
          ? `${btnPos - 115}px`
          : `${btnPos - 100}px`;
      this.nextBtn.style.left =
        window.innerWidth < window.breakpoint
          ? `${btnPos - 63}px`
          : `${btnPos - 48}px`;
    }
  }

  resizeCarousel() {
    this.isMobileVP = !checkMinViewport(window.breakpoint);

    if (this.windowWidth != window.innerWidth) {
      this.flkty.destroy();
      this.setupCarousel();
      this.targetSlideWidth = this.isMobileVP
        ? this.carousel_container.offsetWidth - 40
        : this.carousel_container.offsetWidth;
      this.updateSlideWidth();
      this.windowWidth = window.innerWidth;
    }
  }

  setupCarousel() {
    this.updateSlideWidth();

    this.flkty = new Flickity(this.carousel, {
      // setGallerySize: false,
      accessibility: false,
      prevNextButtons: this.elem.dataset.length > 1,
      pageDots: false,
      autoPlay: false,
      imagesLoaded: true,
      cellAlign: "center",
      wrapAround: true,
      groupCells: true,
      // contain: true,
      on: {
        ready: () => {
          if (this.elem.dataset.length > 1) {
            this.slideTotal.innerText = this.slides.length;
          }

          this.prevBtn = this.elem.querySelector(
            ".flickity-prev-next-button.previous"
          );
          this.nextBtn = this.elem.querySelector(
            ".flickity-prev-next-button.next"
          );

          let btnPos =
            (window.innerWidth - this.carousel_container.offsetWidth) / 2 +
            this.carousel_container.offsetWidth;

          if (this.prevBtn) {
            this.prevBtn.style.left = `${btnPos - 100}px`;
            this.nextBtn.style.left = `${btnPos - 48}px`;
          }

          this.updateSlideWidth();
        },
        change: (index) => {
          if (this.elem.dataset.length > 1) {
            this.slideIndex.innerText = index + 1;
          }
          this.currentSlideIndex = index;
        },
        settle: () => {
          flickitySettleHandler(this.carousel.querySelectorAll(".js-slide"));
        },
      },
    });
  }

  init() {
    this.setupCarousel();

    window.addEventListener("resize", () => {
      this.resizeCarousel();
    });
  }
}
